
import * as React from 'react';
import { switchLayout } from '../../../operations/switchLayout';
import { layoutTypeFacet, availableLayoutsFacet } from '../../../facets/ScopeFacets';
import { IEngagementData } from '../../../facets/LoggerFacets';
import { IItemCacheDispatch } from '../../../store/actions/ItemCacheActions';
import { IFacet } from '../../../models/Facet';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IActionProps, Action, IActionBaseProps } from '../../action/Action';
import { IItemCacheState } from '../../../store/reducers/itemCacheReducer';
import { IDispatch } from '../../../store/actions/createActionCreator';
import { connectToItemsScope } from '../../decorators/connectToItemsScope';
import { IOnExecuteProps } from '../../commandSet/CommandSet';
import { withCurrentItem } from '../../decorators/selectors';

/**
 * @public
 */
export interface ISwitchLayoutActionProps {
  itemKey: string;
  itemsScopeItemKey: string;
  layoutType: IFacet<{}>;
}

/**
 * @public
 */
export const SwitchLayoutAction = withCurrentItem()(connectToItemsScope()(
  connectToItemCache((itemCache: IItemCache, props: ISwitchLayoutActionProps):
    Pick<IActionProps, 'isAvailable' | 'isToggled' | 'engagement'> => {
    const {
      itemKey,
      layoutType,
      itemsScopeItemKey
    } = props;

    const isLayoutCurrent = layoutType === itemCache.demandItemFacet(layoutTypeFacet, itemsScopeItemKey);
    const availableLayouts = itemCache.demandItemFacet(availableLayoutsFacet, itemsScopeItemKey);

    return {
      isAvailable: !!itemKey && !isLayoutCurrent && !!availableLayouts && !!availableLayouts[layoutType.id],
      isToggled: isLayoutCurrent,
      engagement: {
        name: 'SwitchLayout',
        isIntentional: true
      }
    };
  }, (dispatch: IItemCacheDispatch, props: ISwitchLayoutActionProps):
      Pick<IActionProps, 'onExecute'> => {
      const {
        layoutType,
        itemsScopeItemKey
      } = props;

      const onExecute = async () => {
        dispatch(switchLayout({
          itemsScopeItemKey: itemsScopeItemKey,
          layoutType: layoutType
        }));
      };

      return {
        onExecute
      };
    })(Action)
));

// @ts-ignore
type __unused_declarations = Pick<
  IActionBaseProps |
  React.StatelessComponent |
  IItemCacheState |
  IDispatch<never> |
  IOnExecuteProps |
  IEngagementData,
  never>;
